<script setup>

import neededActionToText from "@/helpers/neededActionToText.js";
import BaseDocumentNotification from "@/Components/notifications/BaseDocumentNotification.vue";
import {usePage} from "@inertiajs/vue3";

defineProps({
    notification: {
        type: Object,
        required: true
    }
});

const sendText = (user) => {
    if (user.id === usePage().props.auth.user.id) {
        return 'отправили себе';
    }
    return 'отправил(-а) вам';
}
</script>

<template>
    <BaseDocumentNotification :notification="notification">
        <template #info-text>
            {{ sendText(notification.data.user)}} документ на {{ neededActionToText(notification.data.action) }}.
            <span v-if="'response' in notification.data && notification.data.response">
                Ответ: {{ notification.data.response }}
            </span>
        </template>
    </BaseDocumentNotification>
</template>
